/**
 * Turning university enums into message keys.
 *
 * Every key is returned as a whole literal string rather than built from a
 * template. `scripts/i18n-check.mjs` scans the source for the keys that are
 * actually used, and a computed `` `region_${name}` `` is invisible to it —
 * the catalogue entries would look unused and the check would fail the
 * build over strings that are very much in use.
 */
import type {
  InstitutionType,
  Region,
  ResearchIntensity,
  UniversityFocus,
  UniversitySize
} from '../../lib/api/types'

export function institutionTypeKey(type: InstitutionType): string {
  // Both kinds of private QS tells apart read as "Private" on a card.
  return type === 'public' ? 'typePublic' : 'typePrivate'
}

export function regionKey(region: Region): string {
  if (region === 'africa') return 'regionAfrica'
  if (region === 'americas') return 'regionAmericas'
  if (region === 'asia') return 'regionAsia'
  if (region === 'europe') return 'regionEurope'
  return 'regionOceania'
}

export function sizeKey(size: UniversitySize): string {
  if (size === 's') return 'sizeS'
  if (size === 'm') return 'sizeM'
  if (size === 'l') return 'sizeL'
  return 'sizeXl'
}

export function focusKey(focus: UniversityFocus): string {
  if (focus === 'fc') return 'focusFc'
  if (focus === 'co') return 'focusCo'
  if (focus === 'fo') return 'focusFo'
  return 'focusSp'
}

export function researchKey(research: ResearchIntensity): string {
  if (research === 'vh') return 'researchVh'
  if (research === 'hi') return 'researchHi'
  if (research === 'md') return 'researchMd'
  return 'researchLo'
}
